import { AtSymbolIcon, PhoneIcon, UserCircleIcon } from "@heroicons/react/outline";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateCustomer } from "../Redux/Action/customer.action";

const EditCustomer = ({ editData, setOpenCustPopup }) => {
  const dispatch = useDispatch();
  const [customerData, setCustomerData] = useState({
    name: editData?.name ?? "",
    phone: editData?.phone ?? "",
    email: editData?.email ?? "",
  });
  useEffect(() => {
    if (editData) {
      setCustomerData({
        name: editData?.name ?? "",
        phone: editData?.phone ?? "",
        email: editData?.email ?? "",
      });
    }
  }, [editData]);
  return (
    <div className="p-5 sm:min-w-[460px] flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <h4>Edit Customer Information</h4>
      </div>
      <hr className="main-border-color" />
      <form
        onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
        method="post"
        className="w-full"
      >
        <div className="mb-4 relative input">
          <label>
            Customer Name <span className="text-red-500 ms-1">*</span>
          </label>
          <input
            type="text"
            className="input-secondary"
            value={customerData?.name}
            placeholder="Customer Name"
            onChange={(e) => setCustomerData({ ...customerData, name: e.target.value })}
          />
          <UserCircleIcon className="customer-input-icon w-5 h-5" strokeWidth={1.5} />
        </div>
        <div className="mb-4 relative input">
          <label>
            Customer Phone <span className="text-red-500 ms-1">*</span>
          </label>
          <input
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            className="input-secondary"
            value={customerData?.phone || ""}
            placeholder="Customer Phone"
            maxLength={10}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, ""); // remove non-numbers

              setCustomerData({
                ...customerData,
                phone: value,
              });
            }}
          />
          <PhoneIcon className="customer-input-icon w-5 h-5" strokeWidth={1.5} />
        </div>
        <div className="mb-4 relative input">
          <label>Customer Email</label>
          <input
            type="email"
            className="input-secondary"
            value={customerData?.email}
            placeholder="Customer Email"
            onChange={(e) => setCustomerData({ ...customerData, email: e.target.value })}
          />
          <AtSymbolIcon className="customer-input-icon w-5 h-5" strokeWidth={1.5} />
        </div>
        <button
          type="button"
          onClick={() => {
            dispatch(updateCustomer(editData?._id, customerData));
            setOpenCustPopup(false);
            setCustomerData({ name: "", phone: "", email: "" });
          }}
          disabled={!customerData?.name || !customerData?.phone}
          className={`${!customerData?.name || !customerData?.phone ? "cursor-not-allowed opacity-50" : ""} btn-primary btn-lg text-[18px]`}
        >
          Update
        </button>
      </form>
    </div>
  );
};

export default EditCustomer;
